import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import { useState, useEffect } from 'react';

function usePersistedState(key, defaultState) {
  var _window$localStorage, _JSON$parse;

  var localStorage = (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem(key);
  var initialState = localStorage ? (_JSON$parse = JSON.parse(localStorage)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.value : undefined;

  var _useState = useState(initialState !== null && initialState !== void 0 ? initialState : defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    window.localStorage.setItem(key, _JSON$stringify({
      value: state
    }));
  }, [key, state]);
  return [state, setState];
}

export default usePersistedState;